import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError} from "../../../../../../../../logics/api_config";
import {useApiRentriCalls} from "../../../api-hooks/api_rentri_config";
import {
    IRentriStatoFisico
} from "../../../../../../../../utils/interfaces/special_wasty/rentri/codifiche/rifiuto/IRentriStatoFisico";


const useApiGetRentriStatoFisico = (): UseQueryResult<IRentriStatoFisico[], CustomAxiosError> => {
    const {get} = useApiRentriCalls()

    async function doGet(): Promise<IRentriStatoFisico[]> {
        try {
            const response = await get(`/codifiche/v1.0/lookup/stati-fisici`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetRentriStatoFisico"],
        queryFn: () => doGet(),
    })
};

export default useApiGetRentriStatoFisico